import Studyform from './studyform';

export default (di) => {
	di
		.setType({type: Studyform, name: 'StudyForm', parent: 'PageComponent'})
	;
};
